module.exports = __webpack_public_path__ + "static/media/Logo_Header.59a26e8f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Logo_Header.svg
// module id = 958
// module chunks = 0